import {
    Box,
    Typography,
    IconButton,
    Grid,
    Chip,
    Divider,
    TextField,
    InputAdornment,
    Radio,
    Tooltip,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useEffect, useState } from "react";
import TickIcon from "../../../../../assets/icons/tick_icon.svg";
import CrossIcon from "../../../../../assets/icons/cross_icon.svg";
import { ReactComponent as EditIconSvg } from "../../../../../assets/icons/edit_package_icon.svg";
import { ReactComponent as TickIconSvg } from "../../../../../assets/icons/commission_tick_icon.svg";
import { ReactComponent as CrossIconSvg } from "../../../../../assets/icons/commission_cross_icon.svg";

export const ViewServicePackageCardForPlanner = ({ pkg, onUpdateCommission, }: any) => {
    const [expanded, setExpanded] = useState<boolean>(pkg.id === 1); // first open by default

    const includedServices = pkg.services.filter((s: any) => s.included);
    const excludedServices = pkg.services.filter((s: any) => !s.included);
    const [isEditing, setIsEditing] = useState(false);
    const [commissionType, setCommissionType] = useState<"percentage" | "amount">("");
    const [percentage, setPercentage] = useState<string>(
        pkg.commissionPercentage?.toString() || ""
    );
    const visibleIncluded = includedServices.slice(0, 4);
    const remainingIncludedCount = includedServices.length - visibleIncluded.length;
    const [amount, setAmount] = useState<string>(
        pkg.commissionAmount?.toString() || ""
    );
    const [percentageError, setPercentageError] = useState("");
    const [amountError, setAmountError] = useState("");
    const isSaveDisabled =
        (commissionType === "percentage" &&
            (!percentage || !!percentageError)) ||
        (commissionType === "amount" &&
            (!amount || !!amountError));
    useEffect(() => {
        setPercentage(pkg.commissionPercentage?.toString() || "");
        setAmount(pkg.commissionAmount?.toString() || "");

        if (pkg.commissionPercentage != null) {
            setCommissionType("percentage");
        } else if (pkg.commissionAmount != null) {
            setCommissionType("amount");
        } else {
            setCommissionType("");
        }
    }, [pkg]);

    return (
        <Box
            sx={{
                borderTop: "1px solid #E5E7EB",
                width: "calc(99% )",
                marginLeft: "-20px",
                //m: 2,
                p: 2,
                pl: 4,
                // borderRadius: 2,

            }}
        >
            {/* Header */}
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                onClick={() => setExpanded(!expanded)}
                sx={{ cursor: "pointer" }}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography fontWeight={"500 !important"} color="#212121" fontSize={16} ml={2}>
                        {pkg.name}
                    </Typography>
                    {pkg.price != null && pkg.price !== "" && (
                        <Typography fontWeight={"500 !important"} color="#104145" fontSize={16} ml={2} mr={2}>
                            ${Number(pkg.price).toLocaleString()}
                        </Typography>
                    )}
                    <span
                        className={`status-badge ${pkg.isActive ? "active" : "inactive"}`}
                    >
                        {pkg.isActive ? "Active" : "Inactive"}
                    </span>
                </Box>

                <IconButton>
                    {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
            </Box>

            {/* Description */}
            <Typography variant="body2" sx={{ mt: 1, color: "#6A7282", fontSize: 14, fontWeight: "400 !important" }}>
                {pkg.description}
            </Typography>
            <Box display="flex" alignItems="center" mt="10px" sx={{
                display: "flex",
                alignItems: "center",
            }}>
                {/* LEFT SIDE */}
                <Typography
                    fontSize={14}
                    fontWeight={500}
                >
                    AFP Commission
                </Typography>

                <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

                {/* RIGHT SIDE */}
                <Box sx={{ flex: 1, mt: 0.3 }}>
                    {!isEditing ? (
                        // 🔹 VIEW MODE
                        <Box display="flex" alignItems="center" gap={2}>
                            {(pkg.commissionPercentage != null || pkg.commissionAmount != null) && (
                                <Typography fontSize={14}>
                                    <strong>
                                        {pkg.commissionPercentage != null
                                            ? `${pkg.commissionPercentage}%`
                                            : `$${pkg.commissionAmount}`}
                                    </strong>
                                </Typography>
                            )}
                            <Tooltip
                                title={!pkg.isActive ? "Cannot edit commission for inactive package" : ""}
                                arrow
                            >
                                <span style={{
                                    cursor: !pkg.isActive ? "not-allowed" : "pointer",
                                    display: "inline-flex",
                                    opacity: !pkg.isActive ? 0.5 : 1,
                                }}>
                                    <IconButton
                                        size="small"
                                        disabled={!pkg.isActive}
                                        onClick={(e) => {
                                            e.stopPropagation();

                                            if (pkg.commissionPercentage != null) {
                                                setCommissionType("percentage");
                                                setPercentage(pkg.commissionPercentage.toString());
                                                setAmount("");
                                            } else if (pkg.commissionAmount != null) {
                                                setCommissionType("amount");
                                                setAmount(pkg.commissionAmount.toString());
                                                setPercentage("");
                                            } else {
                                                setCommissionType("");
                                                setPercentage("");
                                                setAmount("");
                                            }

                                            setIsEditing(true);
                                        }}
                                    >
                                        <EditIconSvg />
                                    </IconButton>
                                </span></Tooltip>
                        </Box>
                    ) : (
                        // 🔹 EDIT MODE
                        <Box display="flex" alignItems="flex-start" gap={4}>
                            {/* Percentage */}
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Typography fontSize={14} mb={0.5} ml={6}>
                                    Commission (%)
                                </Typography>

                                <Box display="flex" alignItems="flex-start" gap={1}>
                                    <Radio
                                        size="small"
                                        checked={commissionType === "percentage"}
                                        onChange={() => {
                                            setCommissionType("percentage");

                                            // clear amount immediately
                                            setAmount("");
                                            setAmountError("");
                                        }}

                                    />
                                    <TextField
                                        size="small"
                                        type="number"
                                        value={percentage}
                                        disabled={commissionType !== "percentage"}
                                        error={!!percentageError}
                                        helperText={percentageError || " "}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            // allow only numbers
                                            if (!/^\d*$/.test(value)) return;

                                            // limit digits
                                            if (value.length > 3) return;
                                            if (value.startsWith("0") && value.length > 1) {
                                                value = value.replace(/^0+/, "");
                                            }
                                            if (Number(value) > 100) {
                                                setPercentageError("Value cannot exceed 100%");
                                            } else {
                                                setPercentageError("");
                                            }
                                            setPercentage(value);
                                            setCommissionType("percentage");
                                        }}
                                        onKeyDown={(e) => {
                                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        sx={{
                                            width: 110,
                                            "& .MuiInputBase-root": { height: 32 },
                                            "& input": { padding: "6px 8px", fontSize: 13 },
                                            "& .MuiInputBase-root.Mui-disabled": {
                                                backgroundColor: "#F3F4F6",
                                            },
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">%</InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>

                            {/* Amount */}
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Typography fontSize={14} mb={0.5} ml={6}>
                                    Commission ($)
                                </Typography>

                                <Box display="flex" alignItems="flex-start" gap={1}>
                                    <Radio
                                        size="small"
                                        checked={commissionType === "amount"}
                                        onChange={() => {
                                            setCommissionType("amount");

                                            // clear percentage immediately
                                            setPercentage("");
                                            setPercentageError("");
                                        }}
                                    />
                                    <TextField
                                        size="small"
                                        type="number"
                                        value={amount}
                                        disabled={commissionType !== "amount"}
                                        error={!!amountError}
                                        helperText={amountError || " "}
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            if (!/^\d*$/.test(value)) return;

                                            if (value.startsWith("0") && value.length > 1) {
                                                value = value.replace(/^0+/, "");
                                            }

                                            setAmount(value);
                                            setCommissionType("amount");

                                            if (value.length > 6) {
                                                setAmountError("Maximum 6 digits allowed");
                                            } else {
                                                setAmountError("");
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        sx={{
                                            width: 110,
                                            "& .MuiInputBase-root": { height: 32 },
                                            "& input": { padding: "6px 8px", fontSize: 13 },
                                            "& .MuiInputBase-root.Mui-disabled": {
                                                backgroundColor: "#F3F4F6",
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">$</InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>

                            {/* Action Buttons */}
                            <Box display="flex" alignItems="center" gap={1} mt={3}>
                                <Tooltip
                                    title={isSaveDisabled ? "Fix validation errors before saving" : ""}
                                    arrow
                                >
                                    <span style={{ cursor: isSaveDisabled ? "not-allowed" : "pointer", opacity: isSaveDisabled ? 0.5 : 1 }}>
                                        <IconButton
                                            size="small"
                                            disabled={isSaveDisabled}
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                // check if no value entered
                                                if (commissionType === "percentage" && !percentage) {
                                                    setPercentageError("Please enter a percentage value");
                                                    return;
                                                }

                                                if (commissionType === "amount" && !amount) {
                                                    setAmountError("Please enter an amount value");
                                                    return;
                                                }

                                                // existing validation
                                                if (percentageError || amountError) return;

                                                const value =
                                                    commissionType === "percentage"
                                                        ? Number(percentage)
                                                        : Number(amount);

                                                onUpdateCommission(pkg.id, commissionType, value);

                                                setIsEditing(false);
                                            }}
                                            sx={{ color: "#0F766E" }}
                                        >
                                            <TickIconSvg />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <IconButton
                                    size="small"
                                    sx={{ color: "#DC2626" }}
                                    onClick={(e) => {
                                        e.stopPropagation();

                                        setPercentage(pkg.commissionPercentage?.toString() || "");
                                        setAmount(pkg.commissionAmount?.toString() || "");

                                        if (pkg.commissionPercentage != null) {
                                            setCommissionType("percentage");
                                        } else if (pkg.commissionAmount != null) {
                                            setCommissionType("amount");
                                        } else {
                                            setCommissionType("");
                                        }
                                        setPercentageError("");
                                        setAmountError("");
                                        setIsEditing(false);
                                    }}
                                >
                                    <CrossIconSvg />
                                </IconButton>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>
            {/* Chips */}
            <Box mt={1}>
                {/* ✅ Visible Included Services */}
                {visibleIncluded.map((service: any, index: number) => (
                    <Chip
                        key={index}
                        label={service.name}
                        size="small"
                        sx={{
                            mr: 1,
                            backgroundColor: "#F3F4F6",
                            pt: 2,
                            pb: 2,
                            pl: 1,
                            pr: 1,
                            color: "#374151",
                            fontSize: 12,
                            fontWeight: 400,
                        }}
                    />
                ))}

                {/* ✅ Remaining Included Services */}
                {remainingIncludedCount > 0 && (
                    <Chip
                        label={`+${remainingIncludedCount} included`}
                        size="small"
                       onClick={() => setExpanded((prev) => !prev)} // ⭐ expand on click
                        sx={{
                            mr: 1,
                            backgroundColor: "#e7f6ec",
                            color: "#1a7f37",
                            cursor: "pointer",
                            pt: 2,
                            pb: 2,
                            pl: 1,
                            pr: 1,
                            // ✅ remove hover / active / focus color change

                            // ✅ remove ALL visual effects
                            boxShadow: "none",

                            "&:hover": {
                                backgroundColor: "#e7f6ec",
                                boxShadow: "none",
                            },
                            "&:active": {
                                backgroundColor: "#e7f6ec",
                                boxShadow: "none",
                            },
                            "&:focus": {
                                backgroundColor: "#e7f6ec",
                                boxShadow: "none",
                            },

                            // ✅ remove focus-visible outline/glow
                            "&.Mui-focusVisible": {
                                outline: "none",
                                boxShadow: "none",
                            },

                            // ✅ remove ripple container
                            "& .MuiTouchRipple-root": {
                                display: "none",
                            },
                        }}
                    />
                )}

                {/* ❌ Not Included */}
                {excludedServices.length > 0 && (
                    <Chip
                        label={`+${excludedServices.length} not included`}
                        size="small"
                        onClick={() => setExpanded((prev) => !prev)} // ⭐ optional (nice UX)
                        sx={{
                            mr: 1,
                            backgroundColor: "#E5E7EB",
                            color: "#b91c1c",
                            cursor: "pointer",
                            pt: 2,
                            pb: 2,
                            pl: 1,
                            pr: 1,
                        }}
                    />
                )}
            </Box>

            {/* Expanded Section */}
            {expanded && (
                <>
                    <Divider sx={{ mt: 2, ml: -4, mr: -2.5 }} />
                    <Box
                        sx={{
                            // mt: 2,
                            backgroundColor: "#FAFBFC", // light grey background
                            pl: 6,
                            pt: 2,
                            pb: 2,
                            ml: -4,
                            mr: -2,
                            mb: -2,
                        }}
                    >
                        <Typography fontWeight={500} sx={{ mb: 2, fontSize: 15, color: "#212121", fontWeight: "500 !important" }}>
                            Services Include
                        </Typography>

                        <Grid container spacing={2}>
                            {pkg.services.map((service: any, index: number) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Typography
                                        sx={{
                                            color: service.included ? "#104145" : "#6A7282",
                                            display: "flex",
                                            alignItems: "center",
                                            fontSize: 14,
                                            fontWeight: "400 !important"
                                        }}
                                    >
                                        <img
                                            src={service.included ? TickIcon : CrossIcon}
                                            alt={service.included ? "Included" : "Not Included"}
                                            style={{ marginRight: 8 }}
                                        />
                                        {service.name}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </>
            )}
        </Box>
    );
};